import React, { useEffect, useState } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import { Redirect } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/modal.css";
import COLORS from "../resources/colors/COLORS";
import myToast from "../Utils/MyToast";

/** True when DB flag is on (tm_student_data_options: on_cover_page, on_back_page). */
const isPageFlagOn = (v) =>
  v === "1" || v === 1 || v === true;

const MdlReportCardSettings = ({
  sample_id,
  color_option_id,
  report_card_id,
  actionClose,
  actionDone,
  file_url,
  /** When 1 / true, Data Selection splits into Cover Page vs Back Page; else single list (default). */
  active_cover_page = 0,
}) => {
  const [loggedIn, setLoggedIn] = useState(true);
  const [Loading, setLoading] = useState(false);
  const [show, setShow] = useState(true);
  const [mSampleSettings, setSampleSettings] = useState([]);
  const [mSampleDesignSettings, setSampleDesignSettings] = useState([]);
  const [mSampleDataSettings, setSampleDataSettings] = useState([]);

  const [originalSampleSettings, setOriginalSampleSettings] = useState([]);
  const [font_master, setFont_master] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoggedIn(false);
    }

    getReportCardSettings();
  }, [report_card_id, sample_id, color_option_id]);

  const getReportCardSettings = () => {
    if (!report_card_id || !sample_id || !color_option_id) {
      console.error("Missing required parameters: report_card_id, sample_id, or color_option_id");
      return;
    }

    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const API_NAME = "getStudentReportCardSampleSettings.php";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      API_NAME;
    const params = {
      school_code: SCHOOL_CODE,
      report_card_id: report_card_id,
      sample_id: sample_id,
      color_option_id: color_option_id,
    };
    const queryString = new URLSearchParams(params).toString();
    console.log("Full URL: ", `${URL}${queryString}`);

    axios
      .get(URL, {
        params: params,
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          const rawDesignSettings =
            response.data?.Sample_Design_Settings ??
            response.data?.sample_design_settings ??
            [];
          const designArray = Array.isArray(rawDesignSettings)
            ? rawDesignSettings
            : [];
          const filteredSettings = designArray.filter(
            (item) => item.show_settings === "1"
          );
          if (
            process.env.NODE_ENV !== "production" &&
            designArray.length > 0 &&
            filteredSettings.length === 0
          ) {
            console.warn(
              "MdlReportCardSettings: Sample_Design_Settings had",
              designArray.length,
              "items but none with show_settings === '1'. Check tm_printable_settings_master.show_settings for this sample_id."
            );
          }
          const toShow =
            filteredSettings.length > 0 ? filteredSettings : designArray;

          setSampleDataSettings(response.data?.SampleDataSettings ?? []);
          setSampleDesignSettings(toShow);
          setOriginalSampleSettings(JSON.parse(JSON.stringify(toShow)));
          //setFont_master(response.data.font_master);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error:", error);
        myToast.notify_error("Failed to load report card settings");
      });
  };

  const HandleClose = () => {
    setShow(false);
    actionClose();
  };

  const HandleSubmit = () => {
    setShow(false);
    if (typeof actionDone === "function") {
      actionDone();
    } else {
      actionClose();
    }
  };
  const handleRefreshDialog = () => {
    getReportCardSettings();
  };

  const handleAttrChange = (settingIndex, attrIndex, value) => {
    const updatedSettings = [...mSampleDesignSettings];
    updatedSettings[settingIndex].attribute[attrIndex].attribute_value = value;
    setSampleDesignSettings(updatedSettings);
  };

  const handleResetSetting = (settingIndex) => {
    const original = originalSampleSettings[settingIndex];
    if (!original) {
      return;
    }
    const updated = [...mSampleDesignSettings];
    updated[settingIndex] = JSON.parse(JSON.stringify(original));
    setSampleDesignSettings(updated);
  };

  const applySettingChange = () => {
    const changedSettings = getModifiedSettings();

    if (changedSettings.length === 0) {
      myToast.notify_info("No changes detected.");
      return;
    }

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const mStaffData = SessionManager.getStaffDetails();
    const STAFF_ID = mStaffData?.staff_id;
    const mSession = SessionManager.getCurrentSession();
    const SESSION_ID =
      mSession && mSession[0] ? mSession[0].session_id : null;

    if (!STAFF_ID || !SESSION_ID) {
      myToast.notify_warning(
        "Session or staff info missing. Please refresh and try again."
      );
      return;
    }

    setLoading(true);

    const API_NAME = "AddPrintableSampleSettings.php";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      API_NAME;

    const params = new URLSearchParams();
    params.append("staff_id", STAFF_ID);
    params.append("school_code", SCHOOL_CODE);
    params.append("sample_id", sample_id);
    params.append("color_option_id", color_option_id);
    params.append("session_id", SESSION_ID);
    params.append("sample_settings", JSON.stringify(changedSettings));

    axios
      .post(URL, params)
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          myToast.notify_success("Updated Successfully");
          getReportCardSettings();
          setOriginalSampleSettings(
            JSON.parse(JSON.stringify(mSampleDesignSettings))
          );
        } else {
          myToast.notify_warning(
            response.api_remark || "Update failed. Please try again."
          );
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Apply settings error:", error);
        myToast.notify_error(
          error?.response?.data?.api_remark ||
            "Failed to apply settings. Please try again."
        );
      });
  };

  const getModifiedSettings = () => {
    const modified = [];
    const currentAttrs = Array.isArray(mSampleDesignSettings)
      ? mSampleDesignSettings
      : [];
    const originalAttrs = Array.isArray(originalSampleSettings)
      ? originalSampleSettings
      : [];

    currentAttrs.forEach((currentSetting, sIdx) => {
      const originalSetting = originalAttrs[sIdx];
      const attrList = Array.isArray(currentSetting?.attribute)
        ? currentSetting.attribute
        : [];
      const origAttrList = Array.isArray(originalSetting?.attribute)
        ? originalSetting.attribute
        : [];

      const changedAttributes = attrList.filter((attr, aIdx) => {
        const origVal = origAttrList[aIdx]?.attribute_value;
        return String(attr?.attribute_value ?? "") !== String(origVal ?? "");
      });

      if (changedAttributes.length > 0) {
        modified.push({
          ...currentSetting,
          attribute: changedAttributes,
        });
      }
    });

    return modified;
  };

  /** pageContext: '' = default_status; 'cover' = on_cover_page; 'back' = on_back_page */
  const handleToggle = async (index, pageContext = "") => {
    setLoading(true);
    const newData = [...mSampleDataSettings];
    const item = newData[index];
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const mStaffData = SessionManager.getStaffDetails();
    const STAFF_ID = mStaffData.staff_id;
    const API_NAME = "updateReportCardDataSettings.php";

    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      API_NAME;

    const params = {
      option_id: item.option_id,
      field_options: item.field_options,
      school_code: SCHOOL_CODE,
      staff_id: STAFF_ID,
    };
    if (pageContext === "cover" || pageContext === "back") {
      params.page_context = pageContext;
    }

    const queryString = new URLSearchParams(params).toString();
    console.log("Calling: ", `${URL}?${queryString}`);

    try {
      const response = await axios.get(URL, { params });
      const resData = response.data;
      setLoading(false);

      if (resData.api_status === "OK") {
        const flip = (v) =>
          v === "1" || v === 1 || v === true ? "0" : "1";
        if (pageContext === "cover") {
          newData[index].on_cover_page = flip(item.on_cover_page);
        } else if (pageContext === "back") {
          newData[index].on_back_page = flip(item.on_back_page);
        } else {
          newData[index].default_status = flip(item.default_status);
        }
        setSampleDataSettings(newData);
        myToast.notify_success("Updated Succdessfully");
        getReportCardSettings();
      } else {
        myToast.notify_warning("Failed to update setting");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error updating setting:", error);
      myToast.notify_error("Something went wrong.");
    }
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  const isActiveCoverPageEnabled =
    active_cover_page === 1 ||
    active_cover_page === "1" ||
    active_cover_page === true;

  const dataList = Array.isArray(mSampleDataSettings) ? mSampleDataSettings : [];
  /* Split mode: show every row in both sections; Cover toggles on_cover_page, Back toggles on_back_page */
  const coverPageData = dataList;
  const backPageData = dataList;
  /* Non-split: all rows; switches use default_status */
  const inactiveDataList = dataList;

  const renderDataSwitch = (item, sectionPrefix = "all") => {
    const index = dataList.indexOf(item);
    if (index < 0) {
      return null;
    }
    const keyId = `${sectionPrefix}-${item.option_id}-${index}`;
    const isCoverSection = sectionPrefix === "cover";
    const isBackSection = sectionPrefix === "back";
    const isOn = isCoverSection
      ? isPageFlagOn(item.on_cover_page)
      : isBackSection
        ? isPageFlagOn(item.on_back_page)
        : item.default_status === "1";
    return (
      <div key={keyId} className="col-md-2 col-sm-4 col-6 padding_0">
        <div
          className={
            isOn
              ? "bg_card_green_outline margin_5 padding_5"
              : "bg_card_grey_outline margin_5 padding_5"
          }
        >
          <div className="d-flex justify-content-between align-items-center">
            <span className="fw-bold">{item.field_options}</span>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id={`switch-${keyId}`}
                checked={isOn}
                onChange={() =>
                  handleToggle(
                    index,
                    isCoverSection ? "cover" : isBackSection ? "back" : ""
                  )
                }
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderDataSelectionGrid = (items, sectionPrefix = "all") => (
    <div
      className="row bg_card_primary_outline"
      style={{ margin: "2px 0", padding: "5px" }}
    >
      {items && items.length > 0 ? (
        items.map((item) => renderDataSwitch(item, sectionPrefix))
      ) : (
        <div className="col-12 padding_5 text-muted" style={{ fontSize: "13px" }}>
          No fields for this section.
        </div>
      )}
    </div>
  );

  return (
    <div>
      <Modal
        show={show}
        onHide={HandleClose}
        animation={false}
        className="settings-modal"
        dialogClassName="settings-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>Report Card Settings</Modal.Title>

          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <Button
              className="margin_0 gravity_center"
              variant="outline-secondary"
              onClick={HandleClose}
              style={{ fontSize: "2rem", height: "30px" }}
              title="Close"
            >
              &times;
            </Button>
            <Button
              className="margin_0 gravity_center"
              variant="outline-secondary"
              onClick={handleRefreshDialog}
              style={{ fontSize: "1.5rem", height: "30px" }}
              title="Refresh"
            >
              🔄
            </Button>
            <Button
              style={{ fontSize: "1rem", height: "30px" }}
              className="margin_0 "
              variant="outline-secondary"
              size="sm"
              onClick={() => HandleSubmit()}
            >
              Done
            </Button>
            <Button
              style={{ fontSize: "1rem", height: "30px" }}
              className="margin_0"
              variant="outline-secondary"
              size="sm"
              onClick={() => applySettingChange()}
            >
              Apply
            </Button>
          </div>
        </Modal.Header>

        <Modal.Body>
          {Loading && (
            <div>
              <MyLoader />
            </div>
          )}
          <div className="row settings-scroll" style={{ padding: "0 30px" }}>
            <div className="col-12 padding_0 ">
              <div className="gravity_center" style={{ marginTop: "20px" }}>
                <h3>Data Selection</h3>
              </div>
              {isActiveCoverPageEnabled ? (
                <>
                  <div style={{ marginTop: "12px" }}>
                    <h5
                      style={{
                        fontSize: "15px",
                        fontWeight: 700,
                        marginBottom: "6px",
                        color: "#166534",
                      }}
                    >
                      <i
                        className="fa fa-file-o"
                        style={{ marginRight: "8px" }}
                      />
                      Cover Page
                    </h5>
                    {renderDataSelectionGrid(coverPageData, "cover")}
                  </div>
                  <div style={{ marginTop: "18px" }}>
                    <h5
                      style={{
                        fontSize: "15px",
                        fontWeight: 700,
                        marginBottom: "6px",
                        color: "#1d4ed8",
                      }}
                    >
                      <i
                        className="fa fa-file-text-o"
                        style={{ marginRight: "8px" }}
                      />
                      Back Page
                    </h5>
                    {renderDataSelectionGrid(backPageData, "back")}
                  </div>
                </>
              ) : (
                renderDataSelectionGrid(inactiveDataList)
              )}
            </div>
            <div
              className="col-12 padding_0"
              style={{ margin: "16px 0 0" }}
            >
              <div className="">
                {mSampleDesignSettings &&
                  mSampleDesignSettings.map((setting, sIdx) => (
                    <div
                      key={sIdx}
                      className=" bg_card_primary_outline shadow-sm"
                      style={{ marginBottom: "3px" }}
                    >
                      <div
                        className="bg_card_primary text-white d-flex justify-content-between align-items-center"
                        style={{
                          height: "35px",
                          fontSize: "16px",
                          padding: "0 10px",
                        }}
                      >
                        <div>
                          <strong>{setting.setting_name}</strong>
                        </div>
                        <button
                          type="button"
                          className="btn btn-xs btn-light"
                          onClick={() => handleResetSetting(sIdx)}
                          style={{
                            fontSize: "11px",
                            padding: "2px 8px",
                            borderRadius: "999px",
                            marginTop: "6px",
                          }}
                        >
                          Reset
                        </button>
                      </div>

                      <div className="card-body padding_10">
                        <div className="row">
                          {/* Editable Attributes */}

                          {setting.attribute &&
                            setting.attribute.map((attr, aIdx) => {
                              let options = null;
                              try {
                                if (attr.data_set) {
                                  options = Array.isArray(attr.data_set)
                                    ? attr.data_set
                                    : JSON.parse(attr.data_set);
                                }
                              } catch (e) {
                                console.error(
                                  "Invalid data_set JSON:",
                                  attr.data_set
                                );
                              }

                              // Check if value is a valid hex color code
                              const isHexColor =
                                typeof attr.attribute_value === "string" &&
                                /^#([0-9A-F]{3}){1,2}$/i.test(
                                  attr.attribute_value
                                );

                              return (
                                <div className="col-md-2 padding_2" key={aIdx}>
                                  <div className="mb-2">
                                    <label className="form-label">
                                      {attr.attribute_name}
                                    </label>

                                    {options ? (
                                      <select
                                        className="form-select"
                                        value={attr.attribute_value}
                                        onChange={(e) =>
                                          handleAttrChange(
                                            sIdx,
                                            aIdx,
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option value="">-- Select --</option>
                                        {options.map((option, i) => (
                                          <option key={i} value={option}>
                                            {option}
                                          </option>
                                        ))}
                                      </select>
                                    ) : isHexColor ? (
                                      <div className="d-flex align-items-center gap-1">
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={attr.attribute_value}
                                          onChange={(e) =>
                                            handleAttrChange(
                                              sIdx,
                                              aIdx,
                                              e.target.value
                                            )
                                          }
                                        />
                                        <input
                                          type="color"
                                          className="form-control form-control-color "
                                          value={attr.attribute_value}
                                          onChange={(e) =>
                                            handleAttrChange(
                                              sIdx,
                                              aIdx,
                                              e.target.value
                                            )
                                          }
                                          style={{
                                            width: "50px",
                                            height: "32px",
                                            padding: "1px",
                                            border: "1px solid #ced4da",
                                            borderRadius: "4px",
                                            background: "none",
                                          }}
                                        />
                                      </div>
                                    ) : (
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={attr.attribute_value}
                                        onChange={(e) =>
                                          handleAttrChange(
                                            sIdx,
                                            aIdx,
                                            e.target.value
                                          )
                                        }
                                      />
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MdlReportCardSettings;
